export default __webpack_public_path__ + "static/media/backvector.1bc69c3d.svg";